import { Button, Checkbox, Modal } from "antd";
import classes from "./AdminAddBank.module.css";
import { useState } from "react";
import { useGetPermissionQuery } from "../../../../store/api/permission.api";
import { ModalAddBank } from "../ModalAddBank/ModalAddBank";

export const AdminAgentAddBank = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const { data: permissionData } = useGetPermissionQuery(undefined);

  const banks = permissionData?.data.banks;
  return (
    <>
      <Button
        onClick={() => {
          setModalOpen(true);
        }}
        variant="outlined"
        color="primary"
        className={classes.addBank}
        size="large"
      >
        Добавить банк
      </Button>

      {banks && (
        <ModalAddBank
          open={modalOpen}
          onCancel={() => {
            setModalOpen(false);
          }}
          banks={banks}
        />
      )}
    </>
  );
};
